import { Pipe, PipeTransform } from '@angular/core';
import { stringify } from '@angular/core/src/util';

@Pipe({
  name: 'masterFilter',
  pure: false
})
export class MasterFilterPipe implements PipeTransform {

  private filterBySearchTerm = function (list: any[], searchTerm) {
    const filterBySearchTermList = [];
    for (const item of list) {
      const keyList = Object.keys(item);
      for (const key of keyList) {
        if (
          ((key !== 'updatedOn') && key !== 'createdOn' && !(String(key).includes('Id')))
          || String(key).toLowerCase().includes('emailid')
        ) {
          if (String(item[key]).toLowerCase().includes(searchTerm.toLowerCase())) {
            filterBySearchTermList.push(item);
            break;
          }
        }
      }
    }
    return filterBySearchTermList;
  };

  private filterByOrganisation = function (list, organisation, itemOrgKey1, itemOrgKey2?) {
    // return new Promise(function (resolve, reject) {
    const filterByOrgList = [];
    for (const item of list) {
      if (itemOrgKey2 && itemOrgKey1 && (item[itemOrgKey1][itemOrgKey2] === organisation)) {
        filterByOrgList.push(item);
      } else if (item[itemOrgKey1] === organisation) {
        filterByOrgList.push(item);
      }
    }
    return filterByOrgList;
  };


  transform(value: any, filterObject?: { organisation: any, searchTerm: any },
    itemOrgKey1?: string, itemOrgKey2?: string): any {
    let resultArray = [];
    const objectValues = Object.values(filterObject);
    if (value.length === 0 || (!objectValues[0] && !objectValues[1] && objectValues[2] == null)) {
      return value;
    } else {
      if (filterObject.organisation) {
        let filterByOrgList = [];
        if (itemOrgKey2 && itemOrgKey1) {
          filterByOrgList = this.filterByOrganisation(value, filterObject.organisation, itemOrgKey1, itemOrgKey2);
        } else if (itemOrgKey1) {
          filterByOrgList = this.filterByOrganisation(value, filterObject.organisation, itemOrgKey1);
        }
        if (filterObject.searchTerm) {
          return resultArray = this.filterBySearchTerm(filterByOrgList, filterObject.searchTerm);
        } else {
          return resultArray = filterByOrgList;
        }
      } else if (filterObject.searchTerm) {
        return resultArray = this.filterBySearchTerm(value, filterObject.searchTerm);
      }
    }
  }

  private logFailureMessage(message) {
  }
}




// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/feature-modules/utils/pipes/master-filter.pipe.ts